import identity from "ramda/es/identity";
import prop from "ramda/es/prop";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../constants';
/**
 * Get get root toaster state object
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getToastr(state)
 *
 */ export const getToastr = createSelector(prop(REDUCER_NAME), identity);
/**
 * Get toastr config property
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getConfig(state)
 *
 */ export const getConfig = createSelector(getToastr, prop('config'));
